import { FLIGHT_KEY, HOTEL_KEY, PACKAGE_KEY } from '../constants/categoryConstants';
import { ONEWAY, ROUNDTRIP } from '../constants/tripConstants';
import {
  CLEAR,
  AIR_SEARCH_TYPE,
  HOTEL_SEARCH_TYPE,
  JOURNEY_TYPE,
} from '../constants/recentSearchConstants';
import { CLIENT_ID } from '../constants/apiConstants';
import { generateUUID } from './generateUuidUtils';

const getPayload = ({ journeyType, lobType }) => ({
  context: [
    {
      code: lobType,
      value: CLEAR,
    },
    ...journeyType ? [{
      code: JOURNEY_TYPE,
      value: journeyType,
    }] : [],
  ],
});

const clearSearchFetchRequest = async ({ url, journeyType, lobType }) => {
  await fetch(url,
    {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        clientId: CLIENT_ID,
        correlation_id: generateUUID(),
      },
      body: JSON.stringify(getPayload({ journeyType, lobType })),
    });
};

const getLobType = (lineOfBusiness) => {
  switch (lineOfBusiness) {
    case FLIGHT_KEY:
      return AIR_SEARCH_TYPE;
    case PACKAGE_KEY:
      return AIR_SEARCH_TYPE;
    case HOTEL_KEY:
      return HOTEL_SEARCH_TYPE;
    default:
      return '';
  }
};

const getJourneyType = (isRoundTrip, lineOfBusiness) => {
  if (lineOfBusiness === FLIGHT_KEY || lineOfBusiness === PACKAGE_KEY) {
    return isRoundTrip ? ROUNDTRIP : ONEWAY;
  }
  return '';
};

export const invokeSoftDelete = async ({
  clearHistoryAPIUrl,
  isRoundTrip,
  lineOfBusiness,
  reRunRecentSearchAPI,
}) => {
  const journeyType = getJourneyType(isRoundTrip, lineOfBusiness);
  const lobType = getLobType(lineOfBusiness);
  if (lobType) {
    await clearSearchFetchRequest({
      url: clearHistoryAPIUrl,
      journeyType,
      lobType,
    });
    reRunRecentSearchAPI();
  }
};
